import HOLTER_RR_HEATMAP_COUNT_QUERY from '@/entities/beat/api/queries/holterRrHeatMapCount';
import { apolloQueryWrapper } from '@/shared/api';
import type {
  HolterRrHeatMapCountQuery,
  HolterRrHeatMapCountQueryVariables,
} from '@/shared/api/generated/graphql';

export type HolterRrHeatMapCellTemplate = {
  id: string;
  total: number;
  reviewed: number;
};

export type HolterRrHeatMapCell = {
  id: string;
  row: number;
  col: number;
  reviewed: number;
  total: number;
  templates: HolterRrHeatMapCellTemplate[];
};

export type HolterRrHeatMapCount = {
  isSuccess: boolean;
  message: string;
  rrHeatMapType: string;
  rrHeatMap: HolterRrHeatMapCell[];
};

// TODO(ts): typed as the HolterRrCellsFilter GraphQL input once its server-side shape is documented
/**
 * Loads the RR heat-map cell counts for a study. Runs the holterRrHeatMapCount query with caching on and returns its rrHeatMap payload, throwing the server message when isSuccess is false.
 *
 * @param filter - GraphQL filter narrowing the heat map to a study and time range.
 * @param key - Cancellation key identifying this request.
 * @param needCancel - Whether an in-flight request under the same key is cancelled first.
 * @returns A promise resolving to the RR heat-map count grid.
 */
const fetchHolterRrHeatMapCount = async (filter: any, key?: string | null, needCancel = true) => {
  const result = await apolloQueryWrapper<
    HolterRrHeatMapCountQuery,
    HolterRrHeatMapCountQueryVariables
  >({
    options: {
      query: HOLTER_RR_HEATMAP_COUNT_QUERY,
      variables: {
        filter,
      },
    },
    isUsingCache: true,
    key,
    needCancel,
  });
  const { data } = result;
  const { holterRrHeatMapCount } = data;
  if (holterRrHeatMapCount?.isSuccess) {
    return holterRrHeatMapCount.rrHeatMap;
  }
  throw new Error(holterRrHeatMapCount.message);
};

export default fetchHolterRrHeatMapCount;
